import { GET_STATES_BY_COUNTRIES } from 'modules/dashboard/store/constants';

export const getStatesByCountries = (countries) => ({
  type: GET_STATES_BY_COUNTRIES,
  payload: {
    countries,
  },
});
